/**
 * Enum of meridiem types.
 */
export enum Meridiem {
  AM = 'AM',
  PM = 'PM'
}
